import { FileJpgBoxIcon } from './FileJpgBoxIcon';

/**
 * author: Michael Irigoyen
 * id D5A23F56-0398-40EF-8B0D-640CD1F39669
 * name file-jpg-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-jpg-box.svg
 * tags
 * - Files / Folders 
 */
export const FileJpegBoxIcon = FileJpgBoxIcon;
export default FileJpegBoxIcon